import { render, staticRenderFns } from "./remandMessage.vue?vue&type=template&id=98c4b2d8&"
import script from "./remandMessage.vue?vue&type=script&lang=js&"
export * from "./remandMessage.vue?vue&type=script&lang=js&"
import style0 from "./remandMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports